export const PAYMENT_MODAL_SIZE =
  '!max-h-[min(860px,calc(var(--app-height,100vh)_-_2rem))] !w-[min(576px,calc(100vw_-_2rem))] rounded-md shadow-spread-medium';

export const FORM_LOAD_ERROR_INFO = {
  icon: 'illustration-payment-failed',
  heading: 'Something went wrong',
  description: 'Please try again.'
};

export const PAYMENT_ENTRY_KINDS = {
  CARD: 'card',
  ACH: 'ach'
};

export const PAYMENT_ENTRY_CONFIG = {
  [PAYMENT_ENTRY_KINDS.CARD]: {
    savedMethodType: 'card',
    savedKey: 'saved-cards',
    newKey: 'credit-card',
    title: 'Pay today with your card',
    newTitle: 'Enter card manually',
    icon: 'illustration-credit-card',
    heading: 'Enter your card details',
    description: 'Your card details are encrypted and processed securely.',
    payrocId: 'pay-with-new-card'
  },
  [PAYMENT_ENTRY_KINDS.ACH]: {
    savedMethodType: 'ach',
    savedKey: 'saved-ach',
    newKey: 'new-ach',
    title: 'Pay today with your bank account',
    newTitle: 'Enter banking details',
    icon: 'illustration-credit-card',
    heading: 'Enter your banking details',
    description: 'Your bank details are encrypted and processed securely.',
    payrocId: 'pay-with-new-ach'
  }
};
